import { DmSaitenExtender } from 'division-marker';

// 採点システム拡張
export default class KwiSaitenExtender extends DmSaitenExtender {
    public top_url(user: any): string{
        //   console.log(user.roles)
      if(user == null) return "/dm/sign_in";
      const type = user.type;
      const roles = user.roles;
      console.log('KwiSaitenExtender', roles, roles.includes('kwi_syokuin'))
      if (roles.includes('kwi_syokuin')) {
          return './api/sso/from_dm';
      } else if (this.is_admin(user)) {
        return '#/dm/question_answers';
      } else{
        return '#/dm/question_answers';
      }
    }
}